exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5265db0a] .md-field > div,[data-v-5265db0a] .md-input {\n  width: 100%;\n}\n", ""]);

// exports
